import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import toastErrorIcon from '../../assets/svgs/toast-error.svg';

const OTP_ERROR_TOAST_OPTIONS = {
    icon: <img src={toastErrorIcon} alt="" />,
    className: 'otp-error-toast',
    progressClassName: 'otp-error-toast-progress',
};

export const showOtpErrorToast = (message: string) => toast.error(message, OTP_ERROR_TOAST_OPTIONS);
